var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SHIPPING_RATES = exports.GET_CHECKOUT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const checkoutFragment_1 = require("../fragments/checkoutFragment");
exports.GET_CHECKOUT = (0, graphql_tag_1.default) `
  query GET_CHECKOUT($checkoutId: ID!) {
    node(id: $checkoutId) {
      ... on Checkout {
        ...CheckoutFragment
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
`;
exports.GET_SHIPPING_RATES = (0, graphql_tag_1.default) `
  query GET_SHIPPING_RATES($id: ID!) {
    node(id: $id) {
      ... on Checkout {
        ...CheckoutFragment
        availableShippingRates {
          ready
          shippingRates {
            handle
            priceV2 {
              amount
              currencyCode
            }
            title
          }
        }
      }
    }
  }
  ${checkoutFragment_1.CHECKOUT_FRAGMENT}
`;
//# sourceMappingURL=checkout.js.map